import { Box, Dialog, DialogContent } from '@mui/material';

import { ConvergePdfViewer } from '../../../../presentation';
import { DocumentType } from '@converge/graphql';
import React from 'react';

interface MidtermDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  midtermUuid: string;
  midtermType: string;
}

export const MidtermDocumentModal: React.FC<MidtermDocumentModalProps> = ({
  isOpen,
  onClose,
  midtermUuid,
  midtermType,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      className="policy-document-modal"
      data-testid="policy-document-modal"
    >
      <DialogContent>
        <Box className="pdf-viewer-container">
          {midtermUuid && (
            <ConvergePdfViewer.DownloadedFile
              name=""
              type={midtermType as DocumentType}
              mttUuid={midtermUuid}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
